<template>
    <div class="row" v-show="moduleConfig.filterShow">
        <div class="col-lg-2 col-md-2 attribute-placeholder" v-for="attribute in attributes">
            <label>
                <span>{{ attribute.name }}</span>
                <span class="attribute-number-value" v-if="attribute.type === 2 && !attribute.ui_type">
                    :&nbsp;&nbsp;&nbsp;({{ attribute.min }} - {{ attribute.max }})
                </span>
            </label>
            <multiselect v-if="attribute.type === 1"
                         :placeholder="t('Attributes')"
                         :options="attribute.availableValue"
                         v-model="attribute.value"
                         :group-select="false"
                         :close-on-select="false"
                         :clear-on-select="false"
                         label="value"
                         :maxHeight="300"
                         :custom-label="labelOption"
                         @input="onChangeText(attribute)"
            >
                <div slot="noOptions">{{ t('List is empty') }}</div>
            </multiselect>
            <multiselect v-if="attribute.type === 2 && attribute.ui_type === 4"
                         :placeholder="t('Attributes')"
                         :options="attribute.options"
                         v-model="attribute.value"
                         :group-select="false"
                         :close-on-select="false"
                         :clear-on-select="false"
                         :track-by="'name'"
                         label="name"
                         :maxHeight="300"
                         :custom-label="labelOption"
                         @input="onChangeText(attribute)"
            >
                <div slot="noOptions">{{ t('List is empty') }}</div>
            </multiselect>
            <!--                </div>-->
            <div v-if="attribute.type === 2 && !attribute.ui_type" class="form-inline form-group controls">
                <input type="number" :min="attribute.min" v-model="attribute.value[0]" @change="onChangeNumeric(attribute)" class="controls form-control price-range-input">
                <input type="number" :max="attribute.max" v-model="attribute.value[1]" @change="onChangeNumeric(attribute)" class="controls form-control price-range-input">
            </div>
            <div v-if="attribute.type === 3">
                <toggle-button v-if="attribute.type === 3"
                               @change="onChangeBoolean(attribute)"
                               v-model="attribute.booleanValue"
                               :height="25"
                               :width="70"
                               :labels="getValueForBoolean(attribute)"
                               :sync="attribute.sync"
                />
            </div>
        </div>
    </div>
</template>

<script>

import Multiselect from '../components/Multiselect';
import VueSlider from 'vue-slider-component';

export default
{
    props: {
        config: {
            Type: Object
        },
        eventBus: {
            Type: Object
        },
        moduleConfig: {
            Type: Object
        },
        routeName: {
            Type: String,
            require: true,
        }
    },
    components: {VueSlider, Multiselect},
    data() {
        return {
            attributes: [],
            attributesSelected: [],
            events: [],
            moduleIndex: null,
            interval: null,
            attributesInterval: null,
            state: {},
        };
    },
    computed: {
    },
    beforeDestroy() {
        this.unmountEvents();
    },
    mounted() {
        this.$root.$once('CustomModule:ready', (customModuleEventName, moduleIndex) => {
            this.events.push('CustomModule:ready');
            this.events.push(customModuleEventName);
            this.moduleIndex = moduleIndex;
            this.$root.$on(customModuleEventName, (moduleConfig, state) => {
                this.mountEvents();
                this.init();
            });
        });
    },
    methods: {
        getValueForBoolean: function(attribute) {
            let res = {};
            attribute.availableValue.forEach((value) => {
                if (value.id === attribute.checked) {
                    res['checked'] = value.value;
                }
                if (value.id === attribute.unchecked) {
                    res['unchecked'] = value.value;
                }
            });

            return res;
        },
        init() {
            this.attributes = this.config.data;
        },
        loadData() {
            let _this = this;
            clearInterval(_this.interval);
            let data = this.state;

            _this.interval = setTimeout(() => {
                _this.$http.get(_this.routeName + '/dt-' + _this.config.index, {params: data}).then((response) => {
                    _this.attributes = response.body.data;
                })
            }, 2000);
        },
        labelOption(option) {
            if (option.name) {
                return `${option.name}`;
            }

            return `${option.value}`;
        },
        mountEvents() {
            this.eventBus.$on(`${this.moduleIndex}-ToggleFilterPanel:filter-change`, (filterName, filterValue, filter, filters, serializedFilters) => {
                this.state = Object.assign(this.state, serializedFilters);
                let requestedFilters = ['categories', 'shops'];

                if (requestedFilters.indexOf(filterName) !== -1) {
                    this.attributesSelected = [];
                    this.loadData();
                }
            });
            this.events.push(`${this.moduleIndex}-ToggleFilterPanel:filter-change`);
        },
        onChangeNumeric: function(attribute) {
            let min = parseFloat(attribute.value[0]);
            let max = parseFloat(attribute.value[1]);

            if (!isNaN(min)) {
                attribute.value[0] = min;
            }

            if (!isNaN(max)) {
                attribute.value[1] = max;
            }

            if (isNaN(min) && isNaN(max)) {
                attribute.value = [];
            }

            this.selectAttributes(attribute);
        },
        onChangeText: function(attribute) {
            this.selectAttributes(attribute);
        },
        onChangeBoolean: function(attribute) {
            this.selectAttributes(attribute);
        },
        selectAttributes: function (attribute) {
            let index = this.attributesSelected.findIndex((attr) => {
                return attr.id === attribute.id;
            });
            if (index === -1) {
                this.attributesSelected.push(attribute);
            } else if (attribute.value.length === 0) {
                this.attributesSelected.splice(index, 1);
            }

            let _this = this;
            clearInterval(_this.attributesInterval);
            _this.attributesInterval = setTimeout(() => {
                let serializedAttributes = {};
                _this.$buildAttributes(_this.attributesSelected, serializedAttributes, 'attrValues');
                _this.$root.$emit('AttributesComponent:attributes-change', _this.attributesSelected, serializedAttributes);
            }, 2000);
        },
        unmountEvents() {
            this.events.forEach(e => {
                this.eventBus.$off(e);
            });
        }
    }
}
</script>

<style lang="sass">
@import "../../node_modules/vue-slider-component/theme/default.css";
@import "src/assets/scss/variable.scss";

.attribute-number-value {
    color: $main-background-color;
}
.slider-placeholder {
    margin: 3px 0 3px 15px;
}
.no-border {
    border: none!important;
    box-shadow: none!important;
}
.attribute-placeholder {
    min-height: 100px;
}
</style>


// WEBPACK FOOTER //
// AttributesComponent.vue?46063c28